<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" min-height="1000" persistent width="1000">
      <v-card>
        <v-card-text>
          <v-text-field v-model="currentProblem.subject" :label="$t('problem_dialog.subject')"></v-text-field>
          <v-textarea
            id="problem-description-input"
            v-model="currentProblem.description"
            :label="$t('problem_dialog.description')"
            @focus="changingDescription = true"
            @blur="changingDescription = false"
          ></v-textarea>
          <v-text-field
            v-model="currentProblem.order_code"
            :label="$t('problem_dialog.order_code')"
          ></v-text-field>
          <v-text-field v-model="currentProblem.comment" :label="$t('problem_dialog.comment')"></v-text-field>
          <v-text-field v-model="currentProblem.user_name" :label="$t('problem_dialog.user_name')"></v-text-field>
          <v-select
            v-if="!creating && user.type == 0"
            v-model="currentProblem.status"
            :items="statusNames"
            :label="$t('problem_dialog.status')"
          ></v-select>
          <v-text-field
            type="number"
            step="0.1"
            v-if="!creating && user.type == 0"
            v-model="currentProblem.time_spent"
            :label="$t('problem_dialog.time_spent')"
          ></v-text-field>
          <input type="file" id="files" ref="files" multiple @change="handleFilesUpload" />
          <div class="large-12 medium-12 small-12 cell">
            <div v-for="(file, i) in files" :key="i" class="file-listing">{{ file.name }}</div>
          </div>

          <div class="file-list">
            <div v-for="(attachment, i) in currentProblem.attachments" :key="i">
              {{attachment.file_name}}
              <span>
                <v-icon color="red" small @click="removeAttachment(attachment)">clear</v-icon>
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="creating"
            :disabled="!requiredFieldsFilled"
            color="primary"
            flat
            @click="create"
          >{{$t('problem_dialog.save')}}</v-btn>
          <v-btn
            v-else
            :disabled="!requiredFieldsFilled"
            color="primary"
            flat
            @click="edit"
          >{{ $t('problem_dialog.edit') }}</v-btn>
          <v-btn color="primary" flat @click="dialog = false">{{$t('problem_dialog.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import User from "@/models/User.js";
import Problem from "@/models/Problem.js";
import Attachment from "@/models/Attachment.js";
import StatusName from "@/models/StatusName.js";
export default {
  data() {
    return {
      creating: true,
      files: "",
      dialog: false,
      currentProblem: {
        subject: "",
        description: "",
        order_code: "",
        comment: "",
        user_name: "",
      },
      defaultProblem: {
        subject: "",
        description: "",
        order_code: "",
        comment: "",
        user_name: "",
      },
      user: new User(this.$session.get("user")),
      statusNames: StatusName.getStatusNames(
        this.$session.get("statusNames"),
        "problems"
      ),
      changingDescription: true,
      onKeyUp: (e) => {
        if (e.key === "Enter") {
          if (this.changingDescription) return;
          if (this.creating) {
            this.create();
          } else {
            this.edit();
          }
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.$refs.files.value = "";
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.keyUpHandler);
  },

  computed: {
    requiredFieldsFilled() {
      if (!this.currentProblem.subject) return false;
      if (!this.currentProblem.description) return false;
      if (!this.currentProblem.order_code) return false;
      return true;
    },
  },

  methods: {
    openCreate() {
      this.dialog = true;
      this.creating = true;
      this.currentProblem = { ...this.defaultProblem };
    },

    openEdit(problem) {
      this.dialog = true;
      this.creating = false;
      this.currentProblem = new Problem(problem);
    },

    async create() {
      if (!this.requiredFieldsFilled) return;
      const problem = await Problem.createProblem(this.currentProblem);
      if (this.files) {
        await Attachment.uploadFiles(problem.id, "problems", this.files);
      }
      this.$emit("updated");
      this.dialog = false;
    },

    async edit() {
      if (!this.requiredFieldsFilled) return;
      if (this.currentProblem.status == 2)
        this.currentProblem.solved_at = new Date().toLocaleString("lt-LT");
      await this.currentProblem.save();
      if (this.files) {
        await Attachment.uploadFiles(
          this.currentProblem.id,
          "problems",
          this.files
        );
      }
      this.$emit("updated");
      this.dialog = false;
    },

    handleFilesUpload() {
      this.files = this.$refs.files.files;
    },

    async removeAttachment(attachment) {
      const confirmed = confirm(this.$t("problem_dialog.confirm_delete"));
      if (!confirmed) return;
      await attachment.remove();
      const attachmentIndex = this.currentProblem.attachments.indexOf(
        attachment
      );
      this.currentProblem.attachments.splice(attachmentIndex, 1);
      this.$emit("updated");
    },
  },
};
</script>